import { useCallback, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Keep the active screen with this history entry so refreshing restores it.
export default function usePageViewState(key, initialValue = null) {
  const location = useLocation();
  const navigate = useNavigate();
  const locationRef = useRef(location);
  locationRef.current = location;
  const [value, setValue] = useState(() => Object.prototype.hasOwnProperty.call(location.state?.pageViews || {}, key)
    ? location.state.pageViews[key]
    : typeof initialValue === 'function' ? initialValue() : initialValue);
  const valueRef = useRef(value);
  const update = useCallback(nextValue => {
    const next = typeof nextValue === 'function' ? nextValue(valueRef.current) : nextValue;
    valueRef.current = next;
    setValue(next);
    const current = locationRef.current;
    const state = window.location.pathname === current.pathname
      ? window.history.state?.usr || current.state : current.state;
    navigate(`${current.pathname}${current.search}${current.hash}`, {
      replace: true,
      state: { ...state, pageViews: { ...state?.pageViews, [key]: next } },
    });
  }, [key, navigate]);
  return [value, update];
}
